import { render, staticRenderFns } from "./EventManage.vue?vue&type=template&id=03af773e&scoped=true&"
import script from "./EventManage.vue?vue&type=script&lang=js&"
export * from "./EventManage.vue?vue&type=script&lang=js&"
import style0 from "./EventManage.vue?vue&type=style&index=0&id=03af773e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03af773e",
  null
  
)

export default component.exports